<template>
  <a-modal
    class="attach-sample-modal delete"
    :title="$t('Attach_Del1')"
    :visible="visible"
    :maskClosable="false"
    centered
    @cancel="handleCancel"
  >
    <!-- custom footer -->
    <template v-slot:footer>
      <a-button key="back" @click="handleCancel">{{$t("Common_Cancel")}}</a-button>
      <a-button
        key="submit"
        class="delete-btn"
        :loading="loading"
        @click="handleOk"
      >
        {{$t("Common_Delete")}}
      </a-button>
    </template>

    <!-- contents -->
    <div class="content-text">
      <div>{{$t("Attach_Del2")}}</div>
      <div>{{$t("Attach_Del3")}}</div>
    </div>
    <div class="content-group">
      <ul>
        <li>
          <span class="title">No</span>
          <span class="value">{{ attachInfo.attachInfoNo }}</span>
        </li>
        <li>
          <span class="title">{{$t("Common_Title")}}</span>
          <span class="value">{{ attachInfo.subject }}</span>
        </li>
        <li>
          <span class="title">{{$t("Common_RegDate")}}</span>
          <span class="value">{{
            timeFormatFromUTCEpoch(attachInfo.regEpoch)
          }}</span>
        </li>
      </ul>
    </div>
  </a-modal>
</template>

<script>
import { reactive, toRefs } from "vue";
import { useStore } from "vuex";
import axios from "axios";
import { apiUrl, timeFormatFromUTCEpoch } from "@/utils/common";

export default {
  name: "AttachFileDeleteModal",
  props: {
    visible: Boolean,
    toggleModal: Function,
    attachInfo: Object,
  },
  setup(props) {
    const store = useStore();
    const state = reactive({
      loading: false,
    });

    // 샘플 취소 이벤트
    const handleCancel = () => {
      props.toggleModal();
    };

    // 샘플 삭제 이벤트
    const handleOk = async () => {
      state.loading = true;

      const params = {
        attachInfoNo: props.attachInfo.attachInfoNo,
      };

      try {
        const response = await axios.delete(apiUrl + "AttachFile", {
          params
        });
        if (response && !response.data.error) {
          store.dispatch("attachFile/DELETE_ATTACH_FILE", response);
        }
      } catch (error) {
        console.log("attach file delete error", error);
      }

      state.loading = false;
      props.toggleModal();
    };

    return {
      ...toRefs(state),
      handleCancel,
      handleOk,
      timeFormatFromUTCEpoch,
    };
  },
};
</script>

<style>
</style>